export enum CampaignStatusGroup {
  InProgress = 'InProgress',
  Failed = 'Failed',
  Ready = 'Ready',
}
